import React from 'react'
import CommonScreen from 'admin/component/CommonScreen'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import * as api from '../../../api/pgads'
import { yesNoMap } from 'core'

const additionalEventTagsHeaders = [
  strCol({ ident: 'header1', display: 'Header1', isFiltered: true }),
  strCol({
    ident: 'readonly1',
    display: 'Readonly1',
    isFiltered: true,
    ...toSelectionColProps(yesNoMap),
  }),
  numCol({ ident: 'minVal1', display: 'MinVal1', isFiltered: true }),
  numCol({ ident: 'maxVal1', display: 'MaxVal1', isFiltered: true }),
  strCol({ ident: 'header2', display: 'Header2', isFiltered: true }),
  strCol({
    ident: 'readonly2',
    display: 'Readonly2',
    isFiltered: true,
    ...toSelectionColProps(yesNoMap),
  }),
  numCol({ ident: 'minVal2', display: 'MinVal2', isFiltered: true }),
  numCol({ ident: 'maxVal2', display: 'MaxVal2', isFiltered: true }),
  strCol({ ident: 'header3', display: 'Header3', isFiltered: true }),
  strCol({
    ident: 'readonly3',
    display: 'Readonly3',
    isFiltered: true,
    ...toSelectionColProps(yesNoMap),
  }),
  numCol({ ident: 'minVal3', display: 'MinVal3', isFiltered: true }),
  numCol({ ident: 'maxVal3', display: 'MaxVal3', isFiltered: true }),
  strCol({ ident: 'header4', display: 'Header4', isFiltered: true }),
  strCol({
    ident: 'readonly4',
    display: 'Readonly4',
    isFiltered: true,
    ...toSelectionColProps(yesNoMap),
  }),
  numCol({ ident: 'minVal4', display: 'MinVal4', isFiltered: true }),
  numCol({ ident: 'maxVal4', display: 'MaxVal4', isFiltered: true }),
  strCol({ ident: 'header5', display: 'Header5', isFiltered: true }),
  strCol({
    ident: 'readonly5',
    display: 'Readonly5',
    isFiltered: true,
    ...toSelectionColProps(yesNoMap),
  }),
  strCol({ ident: 'header6', display: 'Header6', isFiltered: true }),
  strCol({
    ident: 'readonly6',
    display: 'Readonly6',
    isFiltered: true,
    ...toSelectionColProps(yesNoMap),
  }),
  strCol({ ident: 'header7', display: 'Header7', isFiltered: true }),
  strCol({
    ident: 'readonly7',
    display: 'Readonly7',
    isFiltered: true,
    ...toSelectionColProps(yesNoMap),
  }),
  strCol({ ident: 'header8', display: 'Header8', isFiltered: true }),
  strCol({
    ident: 'readonly8',
    display: 'Readonly8',
    isFiltered: true,
    ...toSelectionColProps(yesNoMap),
  }),
]
const title = 'Additional Event Tags'

const AdditionalEventTags = () => (
  <CommonScreen
    title={title}
    isAdminScreen
    header={additionalEventTagsHeaders}
    saveTask={api.saveAdditionalEventTags}
    retrieveTask={api.getAdditionalEventTags}
    autoRetrieve
    sortOptions={additionalEventTagsHeaders}
    widthOffset={100}
    autoFixColByKey={false}
    headerRowHeight={60}
    allowInsert={false}
    withDelete={false}
  />
)

export default AdditionalEventTags
